import React, {useContext, useEffect, useState} from 'react'
import {getDetailById} from "../../../services/serviceOffer";
import OfferUpdate from "./OfferUpdate";
import {useParams} from "@reach/router";
import {OfferEditContext} from "../../../context/OfferUpdateContext";

const OfferUpdateContainer = () => {

    const {offerId} = useParams()
    const {byId, bidContent} = useContext(OfferEditContext)
    const [, setOfferById] = byId
    const [, setBidList] = bidContent
    const [read, setRead] = useState(false)

    useEffect(() => {
        getDetailById(offerId)
            .then(({data}) => {
                setOfferById(data)
                if (data.bid.contentOfBidList) {
                    const bidList = data.bid.contentOfBidList.map((item, index) => {
                        const {text, quantity} = getInventoryText(item);
                        return {
                            ...item,
                            stock: {...item.stock, text: text, quantity: quantity},
                            key: index
                        }
                    })
                    setBidList(bidList)
                }
                setRead(true)
            })
    }, [])

    const getInventoryText = (item) => {
        let inventoryText = ''
        let inventoryQuantity = 0
        if (item.hasOwnProperty('inventoryList')) {
            item.inventoryList.forEach(({warehouseName, quantity}) => {
                inventoryQuantity += quantity
                inventoryText += `${warehouseName} - ${quantity},`
            })
        }

        const stockText = `${item?.stock?.code || ''} - ${item?.stock?.name || ''}  ( ${inventoryText} )`

        return {text: stockText, quantity: inventoryQuantity}
    }

    return(
        <React.Fragment>
                {
                    read  ? <OfferUpdate /> : <span> Yükleniyor...</span>
                }
        </React.Fragment>
    )
}
export default OfferUpdateContainer